export default __webpack_public_path__ + "static/media/map.e95bc652.svg";